module.exports = __webpack_public_path__ + "static/media/logo.5eb46397.png";